// extracted by mini-css-extract-plugin
module.exports = {"header":"CreatedAt_header__3U5Py","title":"CreatedAt_title__2oaIT","subtitle":"CreatedAt_subtitle__1BHuT"};